import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogSectionsByLevel1 = (level) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, `getByLevel/${level}`);
    const body = await resp.json();

     debugLogActions(':: catalogSectionActions, startLoadingCatalogSectionsByLevel1', { 'body': body });
    if (body.ok) {

      dispatch(loadingCatalogSectionsLevel1(body.catalogSections));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogSectionsLevel1 = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_LEVEL1,
  payload: catalogsections,
});

export const startLoadingCatalogSectionByParent = (idParent, level) => {
  
  return async (dispatch) => {
    
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGSECTION}`,
      `getByParentId/${idParent}`
    );
    const body = await resp.json();

    if (body.ok) {

      if (level === 2) {
        dispatch(loadingCatalogSectionsLevel2ByParent(body.catalogSections));
      } else if (level === 3) {
        dispatch(loadingCatalogSectionsLevel3ByParent(body.catalogSections));
      } else if (level === 4) {
        dispatch(loadingCatalogSectionsLevel4ByParent(body.catalogSections));
      } else if (level === 5) {
        dispatch(loadingCatalogSectionsLevel5ByParent(body.catalogSections));
      } else if (level === 6) {
        dispatch(loadingCatalogSectionsLevel6ByParent(body.catalogSections));
      }
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogSectionByParentLocal = (idParent, level) => {
  
  return async (dispatch, getState) => {
    const state = getState();

    const { listFullCatalogSections } = state.catalogSection;

    let catalogSections = [];
    listFullCatalogSections.forEach((item) => {
      if (item.parent_id === idParent) {
        catalogSections.push(item);
      }
    })

    if (level === 2) {
      dispatch(loadingCatalogSectionsLevel2ByParent(catalogSections));
    } else if (level === 3) {
      dispatch(loadingCatalogSectionsLevel3ByParent(catalogSections));
    } else if (level === 4) {
      dispatch(loadingCatalogSectionsLevel4ByParent(catalogSections));
    } else if (level === 5) {
      dispatch(loadingCatalogSectionsLevel5ByParent(catalogSections));
    } else if (level === 6) {
      dispatch(loadingCatalogSectionsLevel6ByParent(catalogSections));
    }

  };
};

const loadingCatalogSectionsLevel2ByParent = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_LEVEL2,
  payload: catalogsections,
});

export const selectCatalogSectionLevel1 = (catalogsection) => ({
  type: types.CATALOGSECTION_SELECT_LEVEL1,
  payload: catalogsection,
});

const loadingCatalogSectionsLevel3ByParent = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_LEVEL3,
  payload: catalogsections,
});

export const selectCatalogSectionLevel2 = (catalogsection) => ({
  type: types.CATALOGSECTION_SELECT_LEVEL2,
  payload: catalogsection,
});

const loadingCatalogSectionsLevel4ByParent = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_LEVEL4,
  payload: catalogsections,
});

export const selectCatalogSectionLevel3 = (catalogsection) => ({
  type: types.CATALOGSECTION_SELECT_LEVEL3,
  payload: catalogsection,
});

const loadingCatalogSectionsLevel5ByParent = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_LEVEL5,
  payload: catalogsections,
});

export const selectCatalogSectionLevel4 = (catalogsection) => ({
  type: types.CATALOGSECTION_SELECT_LEVEL4,
  payload: catalogsection,
});

const loadingCatalogSectionsLevel6ByParent = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_LEVEL6,
  payload: catalogsections,
});

export const selectCatalogSectionLevel5 = (catalogsection) => ({
  type: types.CATALOGSECTION_SELECT_LEVEL5,
  payload: catalogsection,
});

export const selectCatalogSectionLevel6 = (catalogsection) => ({
  type: types.CATALOGSECTION_SELECT_LEVEL6,
  payload: catalogsection,
});

export const cleanCatalogSectionLevel1 = () => ({
  type: types.CATALOGSECTION_CLEAN_LEVEL1,
});

export const cleanCatalogSectionLevel2 = () => ({
  type: types.CATALOGSECTION_CLEAN_LEVEL2,
});

export const cleanCatalogSectionLevel3 = () => ({
  type: types.CATALOGSECTION_CLEAN_LEVEL3,
});

export const cleanCatalogSectionLevel4 = () => ({
  type: types.CATALOGSECTION_CLEAN_LEVEL4,
});

export const cleanCatalogSectionLevel5 = () => ({
  type: types.CATALOGSECTION_CLEAN_LEVEL5,
});

export const cleanCatalogSectionLevel6 = () => ({
  type: types.CATALOGSECTION_CLEAN_LEVEL6,
});

export const startLoadingCatalogSectionByCode = (code) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, `getByLevel/${code}`);
    const body = await resp.json();

    if (body.ok) {
      
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogSections = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, "get");
    const body = await resp.json();

    if (body.ok) {
      
      dispatch(loadingCatalogSections(body.catalogSections));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogSections = (catalogSections) => ({
  type: types.CATALOGSECTION_START_LOADING,
  payload: catalogSections,
});

export const startLoadingCatalogSectionsPaginatedBk = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: catalogSectionActions, startLoadingCatalogSectionsPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogSectionsPaginated(body.catalogSectionPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCatalogSectionsPaginated = (page, size, currentCatalogSection = {}) => {
  return async (dispatch) => {

    let sectionCode = "";
    if (currentCatalogSection && Object.keys(currentCatalogSection).length > 0) {
      sectionCode = currentCatalogSection.code;
    }

    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, `get/${page}/${size}/${sectionCode}`);
    const body = await resp.json();

     debugLogActions(':: catalogSectionActions, startLoadingCatalogSectionsPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogSectionsPaginated(body.catalogSectionPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogSectionsPaginated = (catalogSectionPaginated) => ({
  type: types.CATALOGSECTION_START_LOADING_PAGINATED,
  payload: catalogSectionPaginated,
});

export const selectCatalogSections = (catalogSection) => ({
  type: types.CATALOGSECTION_SELECT,
  payload: catalogSection,
});

export const catalogSectionClean = () => ({
  type: types.CATALOGSECTION_CLEAN,
});

export const catalogSectionStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOGSECTION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
              if (body.ok) {
                dispatch(catalogSectionDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogSectionActions, catalogSectionStartDelete', { 'error': error });
    }
  };
};

const catalogSectionDeleted = (id) => {
  return {
    type: types.CATALOGSECTION_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogSectionsPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGSECTION}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(searchingCatalogSectionsPaginated(body.catalogSectionsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogSectionsPaginated = (catalogSectionsPaginated) => ({
  type: types.CATALOGSECTION_START_SEARCH_PAGINATED,
  payload: catalogSectionsPaginated,
});

export const cleanSearchingCatalogSectionsPaginated = () => ({
  type: types.CATALOGSECTION_CLEAN_SEARCH_PAGINATED,
});

export const catalogSectionStartUpdate = (catalogSection, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOGSECTION}`,
        `update/${catalogSection.id}`,
        catalogSection,
        "PUT"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(catalogSectionUpdated(catalogSection));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-section");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogSectionActions, catalogSectionStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalogSection
 * @returns
 */
const catalogSectionUpdated = (catalogSection) => {
  return {
    type: types.CATALOGSECTION_UPDATE,
    payload: catalogSection,
  };
};

export const catalogSectionStartRegister = (catalogSection, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGSECTION}`,
      "add",
      catalogSection,
      "POST"
    );

    const body = await resp.json();

    if (body.ok) {
      dispatch(catalogSectionRegister(body.catalogSection));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-section");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogSectionRegister = (catalogSection) => ({
  type: types.CATALOGSECTION_START_REGISTER,
  payload: catalogSection,
});

export const catalogSectionSetSearchText = (searchText) => ({
  type: types.CATALOGSECTION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogSectionCleanSearchText = () => ({
  type: types.CATALOGSECTION_SET_SEARCH_TEXT,
});

export const startLoadingCatalogSectionsAllByLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, `getByLevel/${6}`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingCatalogSectionsLevel6(body.catalogsections_id));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogSectionsLevel6 = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_ALL_LEVEL6,
  payload: catalogsections,
});

export const startLoadingCatalogSectionsAll = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, `get`);
    const body = await resp.json();

     debugLogActions(':: catalogSectionActions, startLoadingCatalogSectionsAll', { 'body': body });

    if (body.ok) {
      dispatch(loadingCatalogSectionsAll(body.catalogSections));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogSectionsAll = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_ALL,
  payload: catalogsections,
});

export const startLoadingCatalogSectionsNoLevel6 = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGSECTION}`, `get`);
    const body = await resp.json();

     debugLogActions(':: catalogSectionActions, startLoadingCatalogSectionsNoLevel6', { 'body': body });

    if (body.ok) {

      let filterCatalogSections = body.catalogSections.filter(ele => ele.level < 3);

      const sectionWithoutParent = {

        id: 0,
        code: "0000",
        name: "SIN IDENTIFICACIÓN DE ID DE PADRE ",
        level: 0,
        deleted: false,
        code_visual: null,
        createdAt: "2022-10-05T05:20:20.958Z",
        updatedAt: "2022-10-05T05:20:20.958Z",
        parent_id: 9999

      }

      filterCatalogSections.unshift(sectionWithoutParent);

      dispatch(loadingCatalogSectionsNoLevel6(filterCatalogSections));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogSectionsNoLevel6 = (catalogsections) => ({
  type: types.CATALOGSECTION_START_LOADING_NO_LEVEL6,
  payload: catalogsections,
});

export const loadingCatalogSectionFilter = (catalogs) => ({
  type: types.CATALOGSECTION_START_LOADING_FILTER,
  payload: catalogs,
});